import React from "react";
import AssignVendorBulkEdit from "./AssignVendorBulkEdit";

const AssignVendorHodBulkEdit = () => <AssignVendorBulkEdit fixedVariant="hod" />;

export default AssignVendorHodBulkEdit;
